import request from '@/utils/request'

function checkIn (data) {
  return request({
    url: '/pos/ticket/checkIn',
    method: 'post',
    data: data
  })
}

function index (data) {
  return request({
    url: '/pos/ticket/index',
    method: 'post',
    data: data
  })
}

export default {
  checkIn,
  index
}
